import * as time from 'd3-time'
import { extent as _extent } from 'd3-array'

/*
 * Returns the min/max dates from the incoming data.
 */
export const extent = function (data, padding = 0) {
  if (!Array.isArray(data)) {
    // Convert the object to an array
    data = Object.keys(data).map(k => data[k])
  }
  // Flatten all the dates into a single array. Then grabs the extent.
  // Have to be sure to `filter` since the tree node's are stored in a sparse array. es6 spread will blow up
  // if we have a large array
  var range = _extent([].concat(...data.map(d => [d.startDate, d.endDate]).filter(Boolean)))

  return pad(range, padding);
};

/*
 * Pads the incoming date range by the padding percentage.
 */
export const pad = function (range, padding = 0) {
  var padBy = Math.ceil(time.timeDay.count(...range) * padding)

  if (padding && !padBy) {
    // Make sure it's at least one day in case the original dataset
    padBy = 1
  }

  range[0] = time.timeDay.offset(range[0], -padBy)
  range[1] = time.timeDay.offset(range[1], padBy)

  return range
}
